import { Extensions } from '@tiptap/react';
import { CommentsKit } from '@tiptap-pro/extension-comments';
import { TiptapCollabProvider } from '@tiptap-pro/provider';

export interface CommentsExtensionsOptions {
  provider: TiptapCollabProvider;
  onClickThread: (id: string | null) => void;
}

export function createCommentsExtensions(options: CommentsExtensionsOptions): Extensions {
  const { provider, onClickThread } = options;

  return [
    CommentsKit.configure({
      provider,
      onClickThread,
    }),
  ];
}
